module.exports = function _atob(str) {
  return atob(str)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/atob-lite/atob-browser.js
// module id = 220
// module chunks = 0